"use client";

import {
  useAutumnContext
} from "./chunk-EOSHPHLH.mjs";
import {
  AutumnError
} from "./chunk-JNJ53ZW6.mjs";

// src/libraries/react/hooks/usePricingTableBase.tsx
import useSWR from "swr";
var mergeProductDetails = (products, productDetails) => {
  if (!products) {
    return null;
  }
  if (!productDetails) {
    return products;
  }
  let mergedProducts = structuredClone(products);
  for (const product of productDetails) {
    let index = mergedProducts.findIndex((p) => p.id === product.id);
    if (index == -1) {
      console.warn(`Product with id ${product.id} not found`);
      continue;
    }
    mergedProducts[index] = {
      ...mergedProducts[index],
      ...product
    };
  }
  return mergedProducts;
};
var usePricingTableBase = ({
  AutumnContext,
  params
}) => {
  const context = useAutumnContext({ AutumnContext, name: "usePricingTable" });
  const fetcher = async () => {
    try {
      const { data: data2, error: error2 } = await context.client.getPricingTable();
      if (error2) throw error2;
      return data2?.list || [];
    } catch (error2) {
      throw new AutumnError({
        message: "Failed to fetch pricing table products",
        code: "failed_to_fetch_pricing_table_products"
      });
    }
  };
  const { data, error, mutate } = useSWR(
    "pricing-table",
    fetcher
  );
  return {
    products: mergeProductDetails(data || void 0, params?.productDetails),
    isLoading: !error && !data,
    error,
    refetch: mutate
  };
};

export {
  usePricingTableBase
};
